// Actions
const TOGGLE_MENU = 'compare/TOGGLE_MENU';

// Reducer
const initialState = {
  menuOpen: false
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MENU:
      return Object.assign({}, state, { menuOpen: !state.menuOpen });
    default:
      return state;
  }
}

export function toggleMenu() {
  return dispatch => {
    dispatch({
      type: TOGGLE_MENU,
      payload: true
    });
  };
}



// WEBPACK FOOTER //
// ./app/redux-modules/page.js